import { initializeApp } from 'firebase/app';
import { getFirestore, collection } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCN9EJioqXJErWvtNKRPezOljK6IQx2vtU',
  authDomain: 'fir-9-crud-4dd77.firebaseapp.com',
  databaseURL: 'https://fir-9-crud-4dd77-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'fir-9-crud-4dd77',
  storageBucket: 'fir-9-crud-4dd77.appspot.com',
  messagingSenderId: '823532868684',
  appId: '1:823532868684:web:32d3a25d157df8ba4fd0e9',
};

//TODO: Initialize Firebase
const app = initializeApp(firebaseConfig);

//TODO: Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

//TODO: Get a reference to the storage service, which is used to create references in your storage bucket file/images
export const storage = getStorage(app);

//TODO: Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

//TODO: Collection
export const bookCollection = collection(db, 'books');
